import storage from "storage"

export default class StorageManager {
  constructor(namespace) {
    this.namespace = namespace
    if (!this.namespace) throw new Error("StorageManager needs a namespace")
    this.properties = this._loadData()
  }

  _loadData() {
    let data
    if (storage.enabled) data = storage.get(this.namespace)
    if (!data) data = {}
    if (typeof data !== "object") return {}
    return data
  }

  _save() {
    return storage.set(this.namespace, this.properties)
  }

  _checkForObject(dict) {
    if (typeof dict === "object") return
    throw new TypeError("Parameter is not an object", dict)
  }

  get(key) {
    this.properties = this._loadData()
    return this.properties[key]
  }

  getAll() {
    this.properties = this._loadData()
    return {...this.properties}
  }

  set(key, value) {
    this.properties = this._loadData()
    this.properties[key] = value
    this._save()
  }

  register(dict) {
    this._checkForObject(dict)
    this.properties = this._loadData()
    Object.assign(this.properties, dict)
    this._save()
    return this.getAll()
  }

  registerOnce(dict) {
    this._checkForObject(dict)
    this.properties = this._loadData()
    for (const property in dict) {
      if (this.properties[property] === undefined) {
        this.properties[property] = dict[property]
      }
    }
    this._save()
    return this.getAll()
  }

  remove(key) {
    this.properties = this._loadData()
    const value = this.properties[key]
    if (!value) return

    delete this.properties[key]
    this._save()
  }
}
